// all terms should be lower case
// values should be true, because if you find
// an object[key] and it's true, then you know
// you found a restricted term
export const cannabis = {
  cbd: true,
  cannabidiol: true,
  thc: true,
  tetrahydrocannabinol: true,
  cannabis: true,
  marijuana: true,
  indica: true,
  sativa: true,
  dispensary: true,
  edibles: true,
  bong: true,
  // joint: true,
  // pipe: true,
  vaporizer: true,
  // dabbing: true,
  hash: true,
  kief: true,
  canna: true,
  cannabinoid: true,
  cannabigerol: true,
  cannabinol: true,
  cbg: true,
  thca: true,
  cbda: true,
  420: true,
  ganja: true,
  // pot: true,
  reefer: true,
};
